export const EXPEDITION_SYNC_POOLING_INTERVAL = 60 * 1000 * 3; // 3 minutos
